
jQuery(function($) {
    

  /******************************************/
    /********** VAR-----------/
  /******************************************/

  var LARGEUR_MAX_MOBILE = 1024;
  var header = $("#masthead") ,h_header;
  var $TitleMapFooter = $('.Address-Map-Point-Title');
  var h_top_header = header.height();
  var l_window = parseInt($(window).width());

/* AJOIUT NOW ? Vérifier si c'est tout ok ?  */

  $(".BlocTwoCol-Container, .BlocCenterTxt, .BlocCenterVideo").fitVids();

 /******************************************/
    /********** PARALLAX /
  /******************************************/
   $('.History-Item-Img, .HeaderPage-Img, .Equipment-Item-Img, .HeaderPost--bg').parallax({
    speed: 0.3
//    afterRender: doSomething,
  });


  /*************/
  /* SLIDE FORM CONTACT */
/*************/
  $('.ContactContent-Form').slick({
      slidesToShow: 1,
      arrows:false,
      dots:false,
      draggable:false,
      slidesToScroll: 1,
      infinite:false,
      //centerMode: true,
      waitForAnimate:false,
      focusOnSelect: false,
      pauseOnFocus:true

  });

  $(".navSlide a").click(function(a) {
      var e = $(this).index();
      var position_contact_form = $('.navSlide').offset().top - 76;

    $('html, body').stop().animate({
    scrollTop:position_contact_form,
    }, 600, function() {
      // Animation complete.
    });

    
     $(".ContactContent-Form").slick("slickGoTo", parseInt(e));
      a.preventDefault();

  });

    $(".ContactContent-Form").on("beforeChange", function(event, slick, currentSlide, nextSlide) {
      $(".navSlide a").removeClass("active");
      $(".navSlide a:eq(" + nextSlide + ")").addClass("active");
   });


  /* Fin AJout Now */


  /******************************************/
    /********** ANIMATION DANS LA PAGE /
  /******************************************/

// $('.SectionInView').on('inview', function(event, isInView) {
//   if (isInView) {
//     // element is now visible in the viewport
//     $(this).addClass('to_anim');
//   } else {
//      $(this).removeClass('to_anim');

//     // element has gone out of viewport
//   }
// });



                      
                        
// var inview = new Waypoint.Inview({
// element: $('.SectionInView'),
// enter: function(direction) {
//   $('.SectionInView').addClass('to_anim');

//   //console.log('enter');
//   },
//   entered: function(direction) {
//   //demo.reset();
//   //console.log('entered');
//   },
//   exit: function(direction) {
//   $('.SectionInView').removeClass('to_anim');
//   //console.log('exit');
//   },
//   exited: function(direction) {
//   //demo.reset();
//   //console.log('exited');
//   }
// });

var $collection = $('.SectionInView');
$collection.each(function () {
   new Waypoint.Inview({
      element: this,
      enter: function(direction) {
        $(this.element).addClass('to_anim');
        // console.log(this.element.id + ' enter');
      },
      entered: function(direction) {
        // console.log(this.element.id + ' entered');
      },
      exit: function(direction) {
       
      },
      exited: function(direction) {
         $(this.element).removeClass('to_anim');
        // console.log(this.element.id + ' exited');
      }
   });
});

var size_h_big,$grid;
function size_big_elt(){
  l_window = parseInt($(window).width());
  if(l_window > 1023){
  size_h_big = ($('.grid-container .size_normal').first().height()) * 2 + parseInt($('.grid-container .size_normal').first().css('margin-bottom'));
  $('.grid-container .size_big').each(function( index ) {
    $(this).css('height', size_h_big);
  });
 }else{
     $('.grid-container .size_big').css('height', 'auto');
 }
}

$( window ).resize(function() {
  size_big_elt();
  $grid.isotope('layout');
});

 /*************/
    /* ISOTOPE + MASONRY _ REALISATIONS */
  /*************/
size_big_elt();
 $grid = $('.grid-container').imagesLoaded( function() {
      $grid.isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      masonry: {
        // use outer width of grid-sizer for columnWidth
        columnWidth: '.gridpost-sizer',
        gutter: '.gridpost-gutter-sizer',
        // horizontalOrder: true
      }
    });
  });

// $grid.isotope('layout')


  /******************************************/
    /********** PAGE REA  !!! /
  /******************************************/



 
 //// PODOM  => DEMARER OU NE PAS DEMARER LE SLIDE ICI FIRST TIME ? AUTOLOAD ? 

  // POST commands to YouTube or Vimeo API
  function postMessageToPlayer(player, command){
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }

  // When the slide is changing
  function playPauseVideo(slick, control){
    
    var currentSlide, slideType, startTime, player, video;

    currentSlide = slick.find(".slick-current .item");
    slideType = currentSlide.attr("class").split(" ")[1];
    player = currentSlide.find("iframe").get(0);
    startTime = currentSlide.data("video-start");
   
    if (slideType === "vimeo") {
      switch (control) {
        case "play":
          if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
            currentSlide.addClass('started');
            postMessageToPlayer(player, {
              "method": "setCurrentTime",
              "value" : startTime
            });
          }
          postMessageToPlayer(player, {
            "method": "play",
            "value" : 1
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "method": "pause",
            "value": 1
          });
          break;
      }
    } else if (slideType === "youtube") {
      switch (control) {
        case "play":
          // postMessageToPlayer(player, {
          //   "event": "command",
          //   "func": "mute"
          // });
          postMessageToPlayer(player, {
            "event": "command",
            "func": "playVideo"
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "pauseVideo"
          });
          break;
      }
    } else if (slideType === "video") {
      video = currentSlide.children("video").get(0);
      if (video != null) {
        if (control === "play"){
          video.play();
        } else {
          video.pause();
        }
      }
    }
  }



function toInitSlideRea(){
      var slideWrapper = $(".slider-media-js"),
      iframes = slideWrapper.find('.embed-player'),
      lazyImages = slideWrapper.find('.slide-image'),
      lazyCounter = 0;


    // Initialize
    slideWrapper.on("init", function(slick){
      slick = $(slick.currentTarget);
      // setTimeout(function(){
      //   playPauseVideo(slick,"play");
      // }, 1000);
    });
    slideWrapper.on("beforeChange", function(event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick,"pause");
    });
    slideWrapper.on("afterChange", function(event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick,"play");
    });
 

    //start the slider
    slideWrapper.slick({
      // fade:true,
      arrows:false,
      autoplaySpeed:4000,
      lazyLoad:"progressive",
      speed:600,
      dots:false,
      cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)",
      rows:1,
      slidesPerRow:1,
      activateRows:false,
      pauseOnHover:false,
      pauseOnFocus:false,
      draggable:false,
      asNavFor: '.slideMedia-nav',
      responsive: [
          {
            breakpoint: 1024,
            settings: {
             dots: false,
             arrows:false
            }
          }
      ]
    });

  $('.slideMedia-nav').slick({
      slidesToShow: 4,
      arrows:true,
      dots:false,
      draggable:true,
      slidesToScroll: 1,
      asNavFor: '.slider-media-js',
      infinite:false,
      //centerMode: true,
      focusOnSelect: true,
       responsive: [
          {
            breakpoint: 1024,
            settings: {
             dots: false,
             slidesToShow: 3,
             arrows:true
            }
          },
          {
            breakpoint: 768,
            settings: {
             dots: true,
             slidesToShow: 2,
             arrows:false
            }
          }
      ]


  });

  $('.slideMedia-nav').on("beforeChange", function(event, slick) {
    
      var position_elt_history_target = $('.slider-media-js').offset().top - 76;
     $('html, body').stop().animate({ 
              scrollTop: position_elt_history_target
          }, 600);
    });
}

if ( $( ".Media-Slider" ).length ) {
  toInitSlideRea();
}


 /* CREDITS SUR LES VIDEOS */

   $(".VideoCredit--btn").click(function(e){
      if($(this).attr('aria-expanded') == 'true'){
        
        $(this).removeClass('active');
        $(this).attr('aria-expanded', 'false');
        $(this).next().slideUp(500);

       // console.log('h_window = '+ h_window);
          // M0,1080c0,0-11-296.832-11-565C-11,246,0,0,0,0S-57,533,0,1080z
          // mask_forme_menu_svg.stop().animate(2000, 'backOut',0).plot('M0,'+h_window+'c0,0-11-'+l_296+'-11-'+l_565+'C-11,'+l_246+',0,0,0,0S-57,'+l_533+',0,'+h_window+'z'); // podom 2000 au lieu de 1500
      }else{
       
        $(this).addClass('active');
         $(this).attr('aria-expanded', 'true');
         $(this).next().slideDown(500);


         // mask_forme_menu_svg.stop().animate(0, '-',0).plot('M0,'+h_window+'c0,0,'+l_window+'-'+quart_h_courbe+','+l_window+'-'+middle_h+'C'+l_window+','+parseInt(quart_h_courbe+5)+',0,0,0,0S-57,'+l_533+',0,'+h_window+'z');
      }
   });  




  $('.ChiffresCles-Slider').slick({
        //setting-name: setting-value
        dots: false,
        arrows:true,
        draggable:false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed:1400,
        //fade: true,
        pauseOnHover:false,
        pauseOnFocus:false,
     //   infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
               dots: true,
               arrows:false,
               autoplaySpeed: 3000,
            }
          }
          // settings: "unslick"
          // instead of a settings object
        ]
   });
  
   var options = {
        useEasing: true,
        useGrouping: true,
        separator: '',
        decimal: '',
      };

  $('.ChiffresCles-Slider').on("beforeChange",function(event, slick, currentSlide, nextSlide){
    var eltItem = $(slick.$slides.get(nextSlide+3));
    var eltItem_anim = eltItem.find('.chiffre__anim').attr('id');
});


 var $elt_to_change = $('.number-to-change');

$('.SlideGalerieRea-js').slick({
      slidesToShow: 2,
      arrows:true,
      dots:false,
      draggable:true,
      slidesToScroll: 1,
      infinite:true,
        responsive: [
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
               autoplaySpeed: 3000,
            }
          }
          // settings: "unslick"
          // instead of a settings object
        ]
  });

  $('.SlideGalerieRea-js').on("beforeChange", function(event, slick, currentSlide, nextSlide) {
      $elt_to_change.text(nextSlide+1);
  });


   $("#lightgallery").lightGallery({
       subHtmlSelectorRelative: true
  }); 



  $(".wysiwyg .gallery").lightGallery({
      selector:'a',
      subHtmlSelectorRelative: true
  }); 



  
      /// CLOSE SEARCH 
  $( ".js-open_image" ).click(function(evt) {
        var number_elt = $(this).attr("number-elt");
        $( "#lightgallery a" ).eq(number_elt).trigger( "click" );
        evt.preventDefault();
  });



  ///////
  ///// FIN PAGE REA  /////



  /* *****************  */
    /* PAGE L'EQUIPE */
  /* *****************  */

$('.slide-bottom-desc').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slide-top-nav',
    draggable:false
});



$('.slide-top-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slide-bottom-desc',
    infinite:true,
   // centerMode: true,
   focusOnSelect: true,
   responsive: [
        {
          breakpoint: 1152,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows:true
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false,
            arrows:true
          }
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows:true
          }
        }
    ]
});


$(".slide-top-nav").click(function(a) {
    //  var e = $(this).index();
    var position_contact_form = $('.slide-top-nav').offset().top - 76;

    $('html, body').stop().animate({
    scrollTop:position_contact_form,
    }, 600, function() {
      // Animation complete.
    });


  });


     /* SLIDE PARTNER AUTO */


 $('.Partner-Slider-js').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows:false,
  dots:true,
  cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)",
  speed:700,
     responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            arrows:false
          }
        }
    ]

});
    



  /* *****************  */
    /* SMOOTH SCROLL :  INTRO AUTRE PAGE  */
  /* *****************  */

      var menuItems = $('.ToBottom-btn-page');
      var offsetTop;
       menuItems.click(function(e){

      var href = $(this).attr("href"),
          offsetTop = href === "#" ? 0 : $(href).offset().top-h_top_header - 0;
    
          $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 600);
       
        e.preventDefault();
    });


  /******************************************/
    /********** SPECIAL HISTOIRE /
  /******************************************/


 // $(window).scroll(function () {
 //   if($("body").hasClass('page-id-37')){ // Histoire
 //      action_on_scroll_history();
 //    }
 //  });


  $(".History-Nav a, .js-todown, .Equipment-Nav a").click(function(e){
    
    var position_elt_history_target = $($(this).attr('href')).offset().top - 76;

     $('html, body').stop().animate({ 
              scrollTop: position_elt_history_target
          }, 600);
       
   e.preventDefault();
  });


         

// var $EltParentHistory = $('.History-Parent');

// function action_on_scroll_history(){

//   //l_window = parseInt($(window).width());
//   var position_elt_history_parent = $EltParentHistory.offset().top - 200;
//   if ($(window).scrollTop() > position_elt_history_parent){
//     $EltParentHistory.addClass('inner_scroll');
//   }else{
//     $EltParentHistory.removeClass('inner_scroll');
//   }

// }




  /******************************************/
    /********** LIGHTBOX VIDEO HOME PAGE *************/
  /******************************************/

  // $('.open_video_lightbox').featherlight({
  //   type : 'html',
  //   closeIcon: '<i class="icon-close">'
  // });

    // https://stackoverflow.com/questions/45825465/videojs-responsive-lightbox-not-working
    // https://github.com/rudkovskyi/videojs_popup
    // https://dimsemenov.com/plugins/magnific-popup/documentation.html#options
   if($(".open-popup-link"). length){
    videojs.options.flash.swf = "video-js.swf";
    $('document').ready(function(){
      $('.open-popup-link').magnificPopup({
        type:'inline',
        midClick: true,
        mainClass: 'mfp-fade',
        callbacks: {
        open: function() {
           videojs('showreel_lightbox').play();
        },
        close: function() {
          videojs('showreel_lightbox').pause();
        }
        // e.t.c.
      }

      });
      // $('.open-popup-link').on('click',function(){
      //   videojs('showreel_lightbox').play();
      // });
    });
  }




    /*************/
      /* HOVER MAP FOOTER */
  /*************/
  $( ".Address-Map-Point .Point-js" ).hover(
  function() {
    $TitleMapFooter.addClass("activeTitle");
    $TitleMapFooter.text($(this).attr('data-text'));
  }, function() {
    $TitleMapFooter.removeClass("activeTitle");
  }
);


  /*************/
      /* SLIDER DES REA SUR LA HOME  */
  /*************/

   $('.SlideReaHome-js').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
     // fade: true,
      draggable:true,
      dots:false,
      lazyLoad:"progressive",
      cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)",
    //    responsive: [
    //     {
    //       breakpoint: 769,
    //       settings: {
    //         slidesToShow: 2,
    //         slidesToScroll: 1,
    //         arrows: false,
    //         dots: true
    //       }
    //     },
    //     {
    //       breakpoint: 600,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         arrows: false,
    //         dots: true
    //       }
    //     }
    // ]

    });





var activate_scroll_header_menu = true;
var open_menu = false;
var is_home = false;
if($('body').hasClass('home')) is_home = true;

 $(".menu-toggle").click(function(e){
      if($(this).attr('aria-expanded') == 'true'){
        $('body').addClass('header--sticky');
        header.addClass('Masthead--sticky');

        $('body').addClass('open_menu');
        activate_scroll_header_menu = false;
        open_menu = true;

       // console.log('h_window = '+ h_window);
          // M0,1080c0,0-11-296.832-11-565C-11,246,0,0,0,0S-57,533,0,1080z
          // mask_forme_menu_svg.stop().animate(2000, 'backOut',0).plot('M0,'+h_window+'c0,0-11-'+l_296+'-11-'+l_565+'C-11,'+l_246+',0,0,0,0S-57,'+l_533+',0,'+h_window+'z'); // podom 2000 au lieu de 1500
      }else{
         $('body').removeClass('open_menu');
        if ($(window).scrollTop() == 0 && is_home){
            header.removeClass("Masthead--sticky");
            $("body").removeClass('header--sticky');
        }
         activate_scroll_header_menu = true;
         open_menu = false;

         // mask_forme_menu_svg.stop().animate(0, '-',0).plot('M0,'+h_window+'c0,0,'+l_window+'-'+quart_h_courbe+','+l_window+'-'+middle_h+'C'+l_window+','+parseInt(quart_h_courbe+5)+',0,0,0,0S-57,'+l_533+',0,'+h_window+'z');
      }
   });  

  $(".ContainAllMenu--bg").click(function(e){
    if(open_menu){

      $('body').removeClass('open_menu');
        if ($(window).scrollTop() == 0){
            header.removeClass("Masthead--sticky");
            $("body").removeClass('header--sticky');
        }
         activate_scroll_header_menu = true;
         open_menu = false;
         $("#site-navigation").removeClass('toggled');
    }
     
   });
 // $menu = $('.menu-toggle, .ContainAllMenu');

 // $(document).mouseup(function(e){

 //  if(open_menu){
 //     if (!$menu.is(e.target) && $menu.has(e.target).length === 0 && open_menu) // ... nor a descendant of the container // // if the target of the click isn't the container...
 //     {
 //        console.log('NOW');
 //         $(".menu-toggle").trigger( "click" );
 //    }
 //  }
 // });



 $(window).scroll(function () {
   if($("body").hasClass('home')){
      action_on_scroll();
    }
  });

  function action_on_scroll(){

   l_window = parseInt($(window).width());
    h_header = $("#masthead").height();

    if (l_window > LARGEUR_MAX_MOBILE && activate_scroll_header_menu){

       if ($(window).scrollTop() > 100){
        header.addClass("Masthead--sticky");
        $("body").addClass('header--sticky');
        }else{
              header.removeClass("Masthead--sticky");
            $("body").removeClass('header--sticky');
        }
    }else{

      if ($(window).scrollTop() > 0){
        header.addClass("fixed_scrol_mobile");
        $("body").addClass('header--sticky');
          }else{
            header.removeClass("fixed_scrol_mobile");
            $("body").removeClass('header--sticky');
          }
    }
 }

 

// ************************** //
//  SCROLL MAGIC //
// ************************** //



  var controller = null; // pour annuler ou non le controller en fonction de la taille d'écran

  var duration1,offset,h_bloc_imaginer,h_window,size_declenchement_elt,h_bloc_produire,h_bloc_realiser,sceneImaginer1,sceneImaginer_intro,sceneImaginer_txt_slide,sceneProduire1sceneProduireIntro,sceneProduire_txt_slide,sceneRealiser1,sceneRealiserIntro,sceneRealiser_txt_slide;
  if(l_window > LARGEUR_MAX_MOBILE) {
    // On bosse sur les variables si l_window = 1025 ou sup
    duration1 = 600;
    offset = 100;
    h_window = $(window).height();
    size_variable_elt();
  }

  function size_variable_elt(){ // fonction pour remettre à bien les variables de hauteurs de blocs, les tween scrollmagic se servent de ces variables
    h_bloc_imaginer = parseInt($('.SectionImaginer-Block--inner').height() + 170);
    size_declenchement_elt = parseInt((42*h_window)/100);
    h_bloc_produire = parseInt($('.SectionProduire--inner').height() + 120); // + $('.SectionProduire--inner .IntroSection').height() ?  A VOIR 
    h_bloc_realiser = parseInt($('.SectionRealiser--inner').height() + 180);
  }

  // fonction init scrollMagic
  function initScrollMagic(){
    $('body').scrollTop( 0 );
       
        controller = new ScrollMagic.Controller();
        /* A. IMAGINER */
      // 1.0 Section Imaginer //
      // hauteur = hauteur block .SectionImaginer-Block--inner - 50


      /* Pou le pin des elt, il faut pas qu'ils soient en absolute, mais leur parent oui. Sinon, pas possible de redimensionner les left et right en différentes réso.. */

      
      sceneImaginer1 = new ScrollMagic.Scene({triggerElement: "#trigger", duration: h_bloc_imaginer,offset: offset})
        .setPin(".pin_1")
        .setClassToggle(".SectionImaginer", "active_imaginer")
        .addTo(controller);

       // 2.0 Section Imaginer - Disapartion texte intro //
      // hauteur offset = - hauteur block .SectionImaginer-Block--inner

       
      sceneImaginer_intro = new ScrollMagic.Scene({triggerElement: "#trigger_BlockSlideTxt", duration: 2000,offset:-parseInt(size_declenchement_elt+200)})
        .setClassToggle(".SectionImaginer", "Txt_to_desapear")
        .addTo(controller);

      // 3.0 On fait moner le texte à droite du slide 

      
      sceneImaginer_txt_slide = new ScrollMagic.Scene({triggerElement: "#trigger_BlockSlideTxt", duration: 2000,offset: -size_declenchement_elt})
        .setClassToggle(".SectionImaginer .BlockSlideTxt", "active_BlockSlideTxt")
        .addTo(controller);

   /* B. PRODUIRE */

       // 1.0 Section produire //
      // hauteur = hauteur block .SectionProduire--inner - 50

        
        sceneProduire1 =  new ScrollMagic.Scene({triggerElement: "#triggerSectionProduire", duration: h_bloc_produire,offset: offset})
        .setPin(".pin_2")
        .setTween(".SectionProduire--bg", 1, {top: "-500px" }) 
        .setClassToggle(".SectionProduire", "active_produire")
        .addTo(controller);

        // 2.0 Section produire - Disapartion texte intro //
      // hauteur = hauteur block .SectionImaginer-Block--inner - 50

        
        sceneProduireIntro = new ScrollMagic.Scene({triggerElement: "#trigger_BlockSlideTxt2", duration: 2000,offset:-parseInt(size_declenchement_elt+200)})
        .setClassToggle(".SectionProduire", "Txt_to_desapear")
        .addTo(controller);

         // 3.0 On fait moner le texte à droite du slide 

       
      sceneProduire_txt_slide = new ScrollMagic.Scene({triggerElement: "#trigger_BlockSlideTxt2", duration: 2000,offset: -size_declenchement_elt})
        .setClassToggle(".SectionProduire .BlockSlideTxt", "active_BlockSlideTxt")
        .addTo(controller);


    /* C. REALISER */

        // 1.0 Section realiser //
       // hauteur = hauteur block .SectionProduire--inner - 50

        
        sceneRealiser1 = new ScrollMagic.Scene({triggerElement: "#triggerSectionRealiser", duration: h_bloc_realiser,offset: offset})
        .setPin(".pin_3")
        .setTween(".SectionRealiser--bg", 1, {top: "0%" }) 
        .setClassToggle(".SectionRealiser", "active_realiser")
        .addTo(controller);


       
      sceneRealiserIntro  = new ScrollMagic.Scene({triggerElement: "#trigger_BlockSlideTxt3", duration: 2000,offset:-parseInt(size_declenchement_elt+200)})
        .setClassToggle(".SectionRealiser", "Txt_to_desapear")
        .addTo(controller);

      
      sceneRealiser_txt_slide = new ScrollMagic.Scene({triggerElement: "#trigger_BlockSlideTxt3", duration: 2000,offset: -size_declenchement_elt})
        .setClassToggle(".SectionRealiser .BlockSlideTxt", "active_BlockSlideTxt")
        .addTo(controller);

  }

   if(l_window > LARGEUR_MAX_MOBILE) { // 1025
         if($("body").hasClass('home')){
          initScrollMagic();
        }
    }



//}

$( window ).resize(function() {

   if($("body").hasClass('home')){


   h_window = $(window).height();
   l_window = $(window).width();
 


   if( l_window < 1025) {
     // si le controller est présent, alors on le détruit pour tablette et mobile
      if (controller) {
          controller = controller.destroy(true);
      }

  } else if ( l_window > LARGEUR_MAX_MOBILE ) {
     // si on est bien sur une largeur de 1025px et plus

      size_variable_elt(); // on appelle la fonction qui va mettre à jour les variables de hauteurs etc..


      if ( !controller ) {

        // Si pas de controller, on l'instancie
          initScrollMagic();  

      }else{


        // Si le controler est déjà présent, pas besoin de recréer les tween mais simplement de les mettre à jour avec les varialbes..
           
          // Imaginier 
         
         sceneImaginer1.duration(h_bloc_imaginer);

         sceneImaginer_intro.offset(-parseInt(size_declenchement_elt+200));
         sceneImaginer_txt_slide.offset(-size_declenchement_elt);

         // Produire 
       
        sceneProduire1.duration(h_bloc_produire);
        sceneProduireIntro.offset(-parseInt(size_declenchement_elt+200));
        sceneProduire_txt_slide.offset(-size_declenchement_elt);


        // Realiser 
         
         sceneRealiser1.duration(h_bloc_realiser);
         sceneRealiserIntro.offset(-parseInt(size_declenchement_elt+200));
         sceneRealiser_txt_slide.offset(-size_declenchement_elt);

      }
  }

}



});




  // FORM CONTACT LABEL ///

    $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });



 });